import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForYouSection } from './components/ForYouSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy-900 text-slate-300 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainPoints data-id="element-3" />
        <Mechanism data-id="element-4" />
        <WhatYouGet data-id="element-5" />
        <ForYouSection data-id="element-6" />
        <ProofSection data-id="element-7" />
        <FAQSection data-id="element-8" />
        <PricingSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}